import React, {PropsWithChildren, ReactElement, useEffect, useState} from "react"
import {useSwipeable} from "react-swipeable"
import classNames from "classnames"
import {Button} from "antd"
import {useStore} from "@ui/stores"
import CloseIcon from "@ui/icons/common/Close"
import MinimizeIcon from "@ui/icons/common/Minimize"

export enum SwipePanelHeight {
  FULL = "full",
  HALF = "half",
  FITCONTENT = "fit-content"
}

type TSwipePanelProps = {
  className?: string
  header?: ReactElement
  onClose?: () => void
  onSwipe: () => void
  height?: SwipePanelHeight
} & PropsWithChildren

export interface SwipeTouchEvent extends TouchEvent{
  disableSwipe?: boolean
}

const SwipePanel = ({
  children,
  className,
  onClose,
  onSwipe,
  header,
  height = SwipePanelHeight.FITCONTENT
}: TSwipePanelProps): ReactElement => {
  const {settings} = useStore()
  const [show, setShow] = useState(false)

  useEffect(() => {
		setShow(true)
	}, [])

  const fadeOut = (handler: () => void) => {
		setShow(false)
    setTimeout(() => handler(), 700)
	}

  const mobileSwipeHandler = () => {
    settings.isMobile && fadeOut(onSwipe)
  }
  const handlersSwiping = useSwipeable({onSwiping: mobileSwipeHandler})
  const handlersHeaderSwipeDown = useSwipeable({onSwipedDown: mobileSwipeHandler})

  const handlersListSwipeLeft = useSwipeable({
    onSwipedLeft: (eventData) => {
      const event = eventData.event as SwipeTouchEvent
      !settings.isMobile && !event.disableSwipe && fadeOut(onSwipe)
    }
	})

  return (
    <div className={classNames(className, "tongue", {show}, `${height}`)} {...handlersListSwipeLeft}>
      <div className="swipe-toggle" {...handlersSwiping}>
        <div></div>
      </div>
      <div className="tongue-wrapper">
        {header && <div className="header" {...handlersHeaderSwipeDown}>
          {header}
          <div className="actions">
            {settings.isDesktop && <Button
              shape="circle"
              icon={<MinimizeIcon/>}
              onClick={() => fadeOut(onSwipe)}/>
            }
            {onClose && <Button
              shape="circle"
              icon={<CloseIcon/>}
              onClick={() => fadeOut(onClose)}/>
            }
          </div>
        </div>}
        {children}
      </div>
    </div>
  )
}

export default SwipePanel
